<template>
  <div>
    <div class="input-group mb-1">
      <div class="input-group-prepend">
        <select v-model="type" class="form-control">
          <option value="1">Для заявки</option>
          <option value="2">Для накладной</option>
        </select>
      </div>
      <input v-model="number" type="text" placeholder="Трэк номер" class="form-control">
    </div>
    <input type="number" v-model="objectId" placeholder="Номер заявки/накладной" class="form-control mb-1">
    <input type="text" v-model="comment" placeholder="Комментарий" class="form-control">
  </div>
</template>

<script>

import api from "@/api";

export default {
  data() {
    return {
      number: null,
      objectId: null,
      comment: null,
      type: 1,
    }
  },
  methods: {
    async saveData() {
      if (!this.number) {
        toastr['warning']('Номер не указан', 'Ошибка!');
        return false;
      }
      const {data} = await api.post('/new/orders/post/track', {
        action: 'newRecord',
        number: this.number,
        object_id: this.objectId,
        comment: this.comment,
        type: this.type,
      })
      if (data.success) {
        toastr['success']('Трэк номер добавлен', 'Успешно!');
        return true;
      } else {
        toastr['error'](data.message, 'Ошибка!');
        return false;
      }
    }
  }
}

</script>
